import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseApi } from '../components/api';
import { MyUser } from '../global';

export interface AuthState {
    loading: boolean;
    error: string | null;
    success: boolean;
    userName: string;
    userType: 'Admin' | 'User' | 'public';
    userId: number;
    authCode: number;
    token: string;
    isLoggedIn: boolean;
    user:MyUser
    picture:string
}

const initialState: AuthState = {
    loading: false,error: null,success: false,userName: '',userType: 'public',userId: 0, authCode: 0, token: '',
    isLoggedIn: typeof window !== "undefined" ? Number(localStorage.getItem("isLoggedIn") ?? 0) == 1 : false,
    user: typeof window !== "undefined" ? (() => {
        const storedUser = localStorage.getItem("user");
        return storedUser ? JSON.parse(storedUser)
        : {id: null,name: "",email: "",password: "",email_verified: 0,verification_token: "",phone: "",gender: 0,dob: "",points: 0,};
    })()
    : {id: null,name: "",email: "",password: "",email_verified: 0,verification_token: "",phone: "",gender: 0,dob: "",points: 0,},
    picture: typeof window !== "undefined" ? localStorage.getItem("picture") ?? "" : "",
};

// Async thunk for login
export const loginAdmin = createAsyncThunk(
    'auth/loginAdmin',
    async (credentials: { email: string; password: string }, { rejectWithValue }) => {
        try {
            const response = await axios.post(baseApi + '/auth/login', credentials); // Replace with your API endpoint
            const { data } = response.data;
            localStorage.setItem('authData', JSON.stringify(data)); // Save to localStorage for persistence
            return data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.data || 'Login failed');
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState:initialState,
    reducers: {
        resetState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.userName = '';
            state.userType = 'public';
            state.userId = 0;
            state.authCode = 0;
            state.token = '';
            // Clear localStorage
            localStorage.removeItem('authData');
        },
        loadAuthFromStorage: (state) => {
            const storedAuth = typeof window !== "undefined" ? localStorage.getItem('authData') : null;
            if (storedAuth != null && storedAuth != undefined) {
                const parsedAuth = JSON.parse(storedAuth);
                state.userName = parsedAuth.userName;
                state.userType = parsedAuth.userType;
                state.userId = parsedAuth.userId;
                state.authCode = parsedAuth.authCode;
                state.token = parsedAuth.token;
            }
        },
        setUser: (state, action: PayloadAction<MyUser>) => {
            state.user = action.payload;
            state.isLoggedIn = true;
            typeof window !== "undefined" ? localStorage.setItem("isLoggedIn", "1") : null;
            typeof window !== "undefined" ? localStorage.setItem("user", JSON.stringify(action.payload)) : null;
        },
        setPicture: (state, action: PayloadAction<string>) => {
            state.picture = action.payload;
            typeof window !== "undefined" ? localStorage.setItem("picture", action.payload) : null;
        },
        logout: (state) => {
            state.user = {id:null, name:'', email:'', password:'', email_verified:0, verification_token:'', phone:'', gender:0, dob:'', points:0};
            state.isLoggedIn = false;
            typeof window !== "undefined" ? localStorage.removeItem("isLoggedIn") : null;
            typeof window !== "undefined" ? localStorage.removeItem('user') : null;
            typeof window !== "undefined" ? localStorage.removeItem('picture') : null;
            typeof window !== "undefined" ? localStorage.setItem("redirectAfterLogin", window.location.pathname) : null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAdmin.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(loginAdmin.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.success = true;
                state.userName = action.payload.userName;
                state.userType = action.payload.userType;
                state.userId = action.payload.userId;
                state.authCode = action.payload.authCode;
                state.token = action.payload.token;
            })
            .addCase(loginAdmin.rejected, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.error = action.payload || 'Login failed';
            })
    },
});

export const { resetState, loadAuthFromStorage, setUser, logout, setPicture } = authSlice.actions;

export default authSlice.reducer;
